import { useContext, useEffect } from 'react';

import { FEATURE } from '~/common/enums/feature.enum';
import { UserContext } from '~/components/providers/UserProvider';
import { reportPageView } from '~/domains/analytics/events';
import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';
import { useTreatments } from '~/domains/common/hooks/useTreatments';
import { useWelcomeModal, WelcomeModalType } from '~/domains/common/hooks/useWelcomeModal';
import isWebView from '~/utils/isWebView';

type HomeOrder = {
  promotions?: number;
  homeCarousel?: number;
  homeWidgets?: number;
  leaguePills?: number;
  featuredContests?: number;
  quickpicks?: number;
  predictionMarkets?: number;
  popularChannels?: number;
  followers?: number;
  rafBanner?: number;
  contests?: number;
};

export const useHome = () => {
  const { user } = useContext(UserContext);
  const isWebViewValue = isWebView();
  useWelcomeModal(WelcomeModalType.FIRST_LOGIN, !isWebViewValue);

  const isQPpromoEnabled = useIsFeatureEnabled(FEATURE.ENABLE_HOME_QP);
  const isNotificationWidgetsEnabled = useIsFeatureEnabled(
    FEATURE.ENABLE_HOME_NOTIFICATION_WIDGETS
  );
  const isWidgetEnabled = useIsFeatureEnabled(FEATURE.ENABLE_HOME_PREDICTION_MARKETS_WIDGET);
  const isPredictionMarketsEnabled = useIsFeatureEnabled(FEATURE.ENABLE_PREDICTION_MARKETS);
  // Both flags: the widget's "All predictions" link 404s while the markets route gate is off.
  const isPredictionMarketsWidgetEnabled = isWidgetEnabled && isPredictionMarketsEnabled;
  const { isSettled, treatments } = useTreatments([FEATURE.HOME_SECTIONS_ORDER]);
  const { config } = treatments[FEATURE.HOME_SECTIONS_ORDER];
  const homeOrder = (isSettled && (config as HomeOrder)) || {};

  useEffect(() => {
    reportPageView('/', 'Lobby');
  }, []);

  return {
    isQPpromoEnabled,
    isNotificationWidgetsEnabled,
    isPredictionMarketsWidgetEnabled,
    isSignedIn: !!user,
    homeOrder,
  };
};
